// @flow

import Api from './ApiBase';

class IndustriesApi extends Api {
  fetch = async () => {
    const json = await this.request('industries?page[limit]=100');
    const data = await this.deserialize(json);

    return { data };
  }
}

export default new IndustriesApi();
